import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { SystemModulesEnum } from '@/auth/interfaces/system-modules.enum';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { hasSystemModule, texto } from '@/shared/utils';
import { useUserPermissionsStore } from '@/store/auth';
import { useUiStore } from '@/store/ui';

export const useCheckSystemModules = (module: SystemModulesEnum) => {
  const navigate = useNavigate();
  const setAlert = useUiStore(s => s.setAlert);
  const isHydrated = useUserPermissionsStore(s => s.isHydrated);

  useEffect(() => {
    if (!isHydrated) return;
    if (!hasSystemModule(module)) {
      setAlert(true, texto.acceso_denegado_403, AlertSeverityEnum.error);
      navigate('/', { replace: true });
    }
  }, [isHydrated]);
};
